import { gql, useMutation } from '@apollo/client'
import { path } from 'ramda'
import { useNotification } from '@btime/react-messager'
import React from 'react'

import { accountsClient, placesClient } from '../../utils/apollo/api'
import Editable from '../../packages/kiti/components/form/Editable'

const MUTATION = gql`
  mutation UpsertAsset($input: AssetInput) {
    upsertAsset(input: $input) {
      id
    }
  }
`

const cleanRequest = (field, value) => {
  switch (field) {
    case 'place':
      return { placeId: value?.id }
    case 'type':
      return { typeId: value?.id }
    default:
      return { [field]: value }
  }
}

const EditableAsset = ({ record, field, children, ...props }) => {
  const notify = useNotification()
  const [request, { loading }] = useMutation(MUTATION, { refetchQueries: ['Asset'], client: placesClient })

  const handleRequest = value => {
    const params = { variables: { input: { id: record.id, name: record.name, ...cleanRequest(field, value) } } }
    return request(params).then(resp => {
      if (!!resp.errors) {
        notify.error({ title: 'Ocorreu um erro ao salvar!', message: path(['errors', 0, 'message'], resp) })
      }
    })
  }

  return (
    <Editable value={record[field]} onSubmit={handleRequest} loading={loading} {...props}>
      {children}
    </Editable>
  )
}

export default EditableAsset
